import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { CountryCode } from '@/generated/gql/graphql';
import { OptionalContactName } from '~/common/zod/contactName';
import { SupplierContactHitId } from '~/components/SupplierContactAutocomplete';

export const supplierContactFormDataSchema = z.object({
  supplier: z.object({
    internalId: z.string().min(1),
    externalReference: z.string().nullish(),
    name: z.string(),
    location: z.object({
      internalId: z.string(),
      city: z.string().nullable(),
      postalCode: z.string().nullable(),
      address: z.string().nullable(),
      countryCode: z.enum(CountryCode).nullable(),
    }),
    contact: z.object({
      internalId: z.string(),
      email: z.email(),
      firstName: OptionalContactName,
      lastName: OptionalContactName,
      mobile: z.string().nullish(),
      phone: z.string().nullish(),
      language: z.string().transform((value) => value.toUpperCase()),
    }),
  }),
});

export type SupplierContactFormData = z.infer<typeof supplierContactFormDataSchema>;

export const supplierContactFormDataDefault: DefaultValues<SupplierContactFormData> = {
  supplier: {
    contact: {
      internalId: '',
      language: 'DE', // TODO: get default language from admin config here?
      email: '',
      firstName: '',
      lastName: '',
    },
    location: {
      internalId: '',
    },
  },
};

export const TsrctSupplierContactMapper = z.looseObject({
  contact: z.looseObject({
    internalId: z
      .string()
      .nullable()
      .transform((val) => val || SupplierContactHitId.NEW),
  }),
});
